export default function (role) {
  let items = [];

  const establishment_user_items = [
    {
      title: 'label.statistics',
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: '/dashboard',
    },
    {
      title: 'student.sidebar',
      htmlBefore: '<i class="material-icons">assignment_ind</i>',
      to: '/student',
    },
    {
      title: 'book.sidebar',
      htmlBefore: '<i class="material-icons">menu_book</i>',
      to: '/book',
    },
    {
      title: 'contract.sidebar',
      htmlBefore: '<i class="material-icons">volunteer_activism</i>',
      to: '/contract',
    },
  ];

  const admin_items = [
    {
      title: 'label.statistics',
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: '/dashboard',
    },
    {
      title: 'student.sidebar',
      htmlBefore: '<i class="material-icons">assignment_ind</i>',
      to: '/student',
    },

    {
      title: 'establishment-user.sidebar',
      htmlBefore: '<i class="material-icons">manage_accounts</i>',
      to: '/establishment-user',
    },

    {
      title: 'establishment.sidebar',
      htmlBefore: '<i class="material-icons">location_city</i>',
      to: '/establishment',
    },
    {
      title: 'book.sidebar',
      htmlBefore: '<i class="material-icons">menu_book</i>',
      to: '/book',
    },
    {
      title: 'contract.sidebar',
      htmlBefore: '<i class="material-icons">volunteer_activism</i>',
      to: '/contract',
    },
    {
      title: 'author.sidebar',
      htmlBefore: '<i class="material-icons">recent_actors</i>',
      to: '/author',
    },
  ];

  const super_admin_items = [
    {
      title: 'label.statistics',
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: '/dashboard',
    },
    {
      title: 'opu-user.sidebar',
      htmlBefore: '<i class="material-icons">admin_panel_settings</i>',
      to: '/opu-user',
    },
    {
      title: 'action-log.sidebar',
      htmlBefore: '<i class="material-icons">speaker_notes</i>',
      to: '/action-log',
    },
    {
      title: 'student.sidebar',
      htmlBefore: '<i class="material-icons">assignment_ind</i>',
      to: '/student',
    },

    {
      title: 'establishment-user.sidebar',
      htmlBefore: '<i class="material-icons">manage_accounts</i>',
      to: '/establishment-user',
    },

    {
      title: 'establishment.sidebar',
      htmlBefore: '<i class="material-icons">location_city</i>',
      to: '/establishment',
    },
    {
      title: 'book.sidebar',
      htmlBefore: '<i class="material-icons">menu_book</i>',
      to: '/book',
    },
    {
      title: 'contract.sidebar',
      htmlBefore: '<i class="material-icons">volunteer_activism</i>',
      to: '/contract',
    },
    {
      title: 'author.sidebar',
      htmlBefore: '<i class="material-icons">recent_actors</i>',
      to: '/author',
    },
  ];

  switch (role) {
    case 'ESTABLISHMENT_USER':
      items = establishment_user_items;
      break;

    case 'super_admin':
      items = super_admin_items;
      break;

    case 'admin':
      items = admin_items;

      break;

    case 'commercial_admin':
      items = admin_items;

      break;

    default:
      break;
  }

  return items;

  // {
  //   title: 'Forms & Components',
  //   htmlBefore: '<i className="material-icons">view_module</i>',
  //   to: '/components-overview',
  // },
  // {
  //   title: 'Tables',
  //   htmlBefore: '<i className="material-icons">table_chart</i>',
  //   to: '/tables',
  // },
  // {
  //   title: 'User Profile',
  //   htmlBefore: '<i className="material-icons">person</i>',
  //   to: '/user-profile-lite',
  // },
  // {
  //   title: 'Errors',
  //   htmlBefore: '<i className="material-icons">error</i>',
  //   to: '/errors',
  // },
}
